webpackJsonp([0],{

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(15);
	
	var _redux = __webpack_require__(13);
	
	var _Search = __webpack_require__(63);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _Error = __webpack_require__(223);
	
	var _Error2 = _interopRequireDefault(_Error);
	
	var _Footer = __webpack_require__(58);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Error = function (_React$Component) {
	    _inherits(Error, _React$Component);
	
	    function Error(props) {
	        _classCallCheck(this, Error);
	
	        return _possibleConstructorReturn(this, (Error.__proto__ || Object.getPrototypeOf(Error)).call(this, props));
	    }
	
	    _createClass(Error, [{
	        key: 'render',
	        value: function render() {
	            var site = [],
	                M_Search = _react2.default.createElement(_Search2.default, { _Async: true, key: "search" }),
	                M_body = _react2.default.createElement(_Error2.default, { key: "ErrorBody" }),
	                M_Footer = _react2.default.createElement(_Footer2.default, { _ClassName: 'mt0', key: "footer" });
	
	            site.push(M_Search);
	            site.push(M_body);
	            site.push(M_Footer);
	            return _react2.default.createElement(
	                'div',
	                { className: 'site' },
	                site
	            );
	        }
	    }]);
	
	    return Error;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        _global: state.global
	    };
	}, function (dispatch) {
	    return {
	        global: (0, _redux.bindActionCreators)(global, dispatch)
	    };
	})(Error);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ConfigExpr = __webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Producer -- Rowe
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Time -- 2017/9/4
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Function -- 404
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ErrorBody = function (_React$Component) {
	    _inherits(ErrorBody, _React$Component);
	
	    function ErrorBody(props) {
	        _classCallCheck(this, ErrorBody);
	
	        var _this = _possibleConstructorReturn(this, (ErrorBody.__proto__ || Object.getPrototypeOf(ErrorBody)).call(this, props));
	
	        _this.goWhere = _this.goWhere.bind(_this);
	        return _this;
	    }
	
	    _createClass(ErrorBody, [{
	        key: "goWhere",
	        value: function goWhere(address) {
	            window.location.href = address;
	        }
	    }, {
	        key: "render",
	        value: function render() {
	
	            var LocationHost = (0, _ConfigExpr.getEnv)(process.title, "localhost");
	
	            return _react2.default.createElement(
	                "div",
	                { className: "sepError clearFix" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "banner" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "center" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "goButton", onClick: this.goWhere.bind(this, "/") },
	                            _react2.default.createElement(
	                                "p",
	                                null,
	                                "\u901B\u901B\u522B\u7684"
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                null,
	                                " > "
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "buttonArea" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "center" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "module" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "text" },
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    "\u7545\u9500\u699C\u5355"
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    _react2.default.createElement(
	                                        "span",
	                                        null,
	                                        "HOT"
	                                    ),
	                                    _react2.default.createElement(
	                                        "span",
	                                        null,
	                                        "SALES"
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "goWhereButton", onClick: this.goWhere.bind(this, "http://" + LocationHost + "/rank/") },
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    "\u7ACB\u5373\u524D\u5F80"
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    " > "
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "module Ml70" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "text" },
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    "\u793C\u7269\u5957\u88C5"
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    _react2.default.createElement(
	                                        "span",
	                                        null,
	                                        "GIFT"
	                                    ),
	                                    _react2.default.createElement(
	                                        "span",
	                                        null,
	                                        "SETS"
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "goWhereButton", onClick: this.goWhere.bind(this, '/gift_set.html') },
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    "\u7ACB\u5373\u524D\u5F80"
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    " > "
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "module Ml70" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "text" },
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    "\u6BCF\u5468\u7279\u60E0"
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    _react2.default.createElement(
	                                        "span",
	                                        null,
	                                        "WEEKLY"
	                                    ),
	                                    _react2.default.createElement(
	                                        "span",
	                                        null,
	                                        "SPECIAL"
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "goWhereButton", onClick: this.goWhere.bind(this, "http://" + LocationHost + "/campaign/weeklyspecials0323/") },
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    "\u7ACB\u5373\u524D\u5F80"
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    " > "
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ErrorBody;
	}(_react2.default.Component);
	
	exports.default = ErrorBody;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ })

});


// WEBPACK FOOTER //
// 0.soa/bundle/0_f1010e2dcfcfc8f1da09.js